import * as React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import { IAdditionalIncome } from "../../../../model/report/applicantdata/AdditionalIncome";
import NumberFormatter from "../../../../model/common/NumberFormatter";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const PDFExportAdditionalIncome = ({
  translate,
  data
}: {
  translate?: any;
  data?: IAdditionalIncome[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <View>
      <View style={styles.titleCol}>
        <Text style={styles.header}>
          {translate("report8.document_template.additional_income.title")}
        </Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate("report8.document_template.additional_income.name")}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.additional_income.income_type"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.additional_income.income_source"
              )}
            </Text>
          </View>
          <View style={styles.tableDateCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.additional_income.date_from"
              )}
            </Text>
          </View>
          <View style={styles.tableDateCol}>
            <Text style={styles.tableCell}>
              {translate("report8.document_template.additional_income.date_to")}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={{ ...styles.tableCell, textAlign: "right" }}>
              {translate(
                "report8.document_template.additional_income.total_income"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.additional_income.description"
              )}
            </Text>
          </View>
        </View>
        {data?.map((item, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.name}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.incomeType}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.incomeSource}</Text>
            </View>
            <View style={styles.tableDateCol}>
              <Text style={styles.tableCell}>{item.dateFrom} </Text>
            </View>
            <View style={styles.tableDateCol}>
              <Text style={styles.tableCell}>{item.dateTo}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {NumberFormatter().formatReadOnlyValue(item.totalIncome)}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.description} </Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default PDFExportAdditionalIncome;
Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});

const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "10pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  header: {
    fontSize: "12pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    marginBottom: 20,
    marginLeft: 5
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "15.2%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableDateCol: {
    width: "12%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  }
});
